import { render, staticRenderFns } from "./Permission-Settings.vue?vue&type=template&id=1b74f592&scoped=true&"
import script from "./Permission-Settings.vue?vue&type=script&lang=js&"
export * from "./Permission-Settings.vue?vue&type=script&lang=js&"
import style0 from "./Permission-Settings.vue?vue&type=style&index=0&id=1b74f592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b74f592",
  null
  
)

export default component.exports